<template>
	<div class="feature">
		<div class="feature-icon">
			<img :src="featureImage" :alt="feature.text" class="m-auto">
		</div>
		<p :class="`feature-${state}`">
			{{ feature.text }}
		</p>
		<div class="tooltip-container">
			<tooltip>
				<template v-if="state == 'active'">
					{{ feature.tooltip.included }}
				</template>
				<template v-else>
					<p class="tooltip-missing" v-html="feature.tooltip.missing" />
				</template>
			</tooltip>
		</div>
	</div>
</template>

<script>
import Tooltip from "@c/generals/tooltip";

export default {
	name: "FeatureIcon",
	components: {
		Tooltip
	},
	props: {
		feature: {
			type: Object,
			required: true
		}
	},
	computed: {
		featureImage() {
			return this.feature.image[this.state];
		},
		state() {
			return this.feature.isActive ? "active" : "inactive";
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.feature {
	margin-right: 5px;
	width: 95px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;

	&-icon {
		height: 30px;
		width: 30px;
		margin-bottom: 5px;

		img {
			margin: 0 auto;
			display: block;
			height: 25px;
			width: 25px;
		}
	}

	&-active {
		color: #7c1e95;
	}

	&-inactive {
		color: #9fa9b2;
	}

	&-active,
	&-inactive {
		text-align: center;

		@media (min-width: 320px) and (max-width: 580px) {
			font-size: 12px;
		}
	}
}

.tooltip-container {
	position: absolute;
	display: none;
}

.feature:hover {
	.tooltip-container {
		display: block;
	}
}

.feature::v-deep {
	.help-tooltip {
		padding: 15px;
		transform: translate(-100%, -140%) !important;

		.tooltip-missing {
			margin: 0;
			span {
				font-size: 16px;
				color: #BF4CBF;
				font-family: 'Akkurat-Bold';
			}
		}
	}
}
</style>
